<ng-container *ngIf="!isLoading else loading">
	<div class="card-title">
		<span class="title-align" translate>auction.overview</span>
	</div>
	<ng-container *ngIf="openedAuctionOffersCount && openedAuctionOffersCount > 0; else noOpenedAuctionOffers">
		<div class="container" *ngIf="familyTonnage && openedAuctionOffersAggregate && openedAuctionOffersCount">
			<div class="auction-family-container">
				<button type="button" mat-ripple class="pill auction-family-content" *ngFor="let family of familyTonnage.slice(0, 6)"
					(click)="viewDetails()">
						<span 
							class="family-info" 
							[title]="family.productFamilyDescription + ' - ' + (family.tonnage | copoNumber:'weight':(UNIT_OPTIONS['to'].symbol ))">
								{{family.productFamilyDescription}} - {{family.tonnage | copoNumber:'weight':(UNIT_OPTIONS['to'].symbol )}}
						</span>
				</button>
			</div>
			<div class="auction-info">
				<mat-icon svgIcon="auction_gavel_icon"></mat-icon>
				<div class="auction-tonnage-label label-orange-color">{{openedAuctionOffersAggregate | copoNumber:'weight':(UNIT_OPTIONS['to'].symbol )}}</div>
				<div class="auction-total">{{openedAuctionOffersCount}} {{'auctions.opened' | translate}}</div>
			</div>
		</div>
		<div class="mill-block" *ngIf="millTonnage">
			<button type="button" mat-ripple *ngFor="let mill of millTonnage.slice(0, 6)" class="mill-row"
				(click)="viewDetails()">
				<div class="icon-container">
					<mat-icon class="mill-icon mat-icon label-orange-color" role="img" svgIcon="icon_mill"></mat-icon>
				</div>
				<div class="mill-info">
					<span class="mill-name-align">{{ mill.mill }}</span>
					<div class="mill-link">
						<span class="mill-tonnage">{{ mill.tonnage | copoNumber:'weight':(UNIT_OPTIONS['to'].symbol ) }}</span>
						<mat-icon class="mill-line-chevron" color="accent" svgIcon="md:chevron_right"></mat-icon>
					</div>
				</div>
			</button>
		</div>
	</ng-container>
	<ng-template #noOpenedAuctionOffers>
		<span class="no-auction" translate>auction-offer.now-rows</span>
	</ng-template>
</ng-container>
<ng-template #loading>
	<copo-loading-spinner></copo-loading-spinner>
</ng-template>